export default __webpack_public_path__ + "static/clip-online-shopping-7-e31e84127b4344a4dd9dc587f22bf017.png";